import { render } from "./ProviderRankings.vue?vue&type=template&id=27f45a40&scoped=true"
import script from "./ProviderRankings.vue?vue&type=script&lang=js"
export * from "./ProviderRankings.vue?vue&type=script&lang=js"

import "./ProviderRankings.vue?vue&type=style&index=0&id=27f45a40&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f45a40"]])

export default __exports__